export default defineNuxtRouteMiddleware(async (to, from) => {
    const orgSlug = to.params.org_slug;

    // Skip if no org_slug in route
    if (!orgSlug) return;

    // Get or create org state
    const orgData = useState('orgData', () => null);
    const checkedOrgSlug = useState('checkedOrgSlug', () => null);

    // Only check if org_slug has changed or not checked yet
    if (checkedOrgSlug.value === orgSlug && orgData.value) {
        return;
    }

    try {
        const config = useRuntimeConfig();
        const nuxtApp = useNuxtApp();
        // Get cookies in middleware context
        const arst = useCookie('arst');
        const auat = useCookie('auat');
        const uid = useCookie('uid');

        // Skip if no auth cookies
        if (!arst.value || !auat.value) {
            return;
        }

        // Build headers
        const headers = {
            'app': 'pp',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (arst.value) {
            headers['revocable-session-token'] = arst.value;
        }

        if (auat.value) {
            headers['access_token'] = auat.value;
            headers['Authorization'] = `Bearer ${auat.value}`;
        }

        if (uid.value) {
            headers['user_id'] = uid.value;
        }

        // Make the API call
        const response = await $fetch(`${config.public.apiUrl}/auth-org`, {
            method: 'GET',
            headers,
            query: {
                slug: orgSlug
            }
        });

        orgData.value = response;
        checkedOrgSlug.value = orgSlug;

    } catch (error) {
        console.error('Auth org error:', error);

        // Get the status code from the error
        const statusCode = error.data?.statusCode || error.statusCode || error.status;

        // Handle 404 - organization not found
        if (statusCode === 404) {
            return navigateTo(`/error?code=404&message=${encodeURIComponent('Organization not found')}`);
        }

        // Handle 403 - forbidden
        if (statusCode === 403) {
            return navigateTo(`/error?code=403&message=${encodeURIComponent('Access to this organization is forbidden')}`);
        }

        // Handle other errors
        if (statusCode) {
            return navigateTo(`/error?code=${statusCode}&message=${encodeURIComponent(error.data?.statusMessage || error.statusMessage || 'Failed to authorize organization access')}`);
        }

        // For unknown errors, log but don't block access
        console.error('Failed to fetch org data:', error);
    }
});
